import { jsx } from "react/jsx-runtime";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { validateTidalLicense } from "../../base/index.js";
function ViewColumn(props) {
  return /* @__PURE__ */ jsx(
    ViewColumnIcon,
    {
      "data-testid": "ViewColumn",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ViewColumn",
      "data-tidal-icon-meta": "layout"
    }
  );
}
ViewColumn.tidalIconMeta = {
  categories: "layout",
  name: "ViewColumn"
};
validateTidalLicense();
export {
  ViewColumn
};
//# sourceMappingURL=ViewColumn.js.map
